import React, { useEffect } from "react";
import { AppState, AppThunkDispatch } from "../store";
import { connect } from "react-redux";
import { getRouteItems } from "../store/route";
import { thunkUpdateRouteItems } from "../store/route/action";
import { thunkUpdateDomain } from "../store/domain/action";
import { getDomain } from "../store/domain";
import GlobalStyle from "../aat/components/GlobalStyle/GlobalStyle";
import Footer from "../aat/components/Footer/Footer";
import { showBasketAsync, showLoginAsync } from "../store/basm/action";
import styled from "styled-components";
import { getBackdrop } from "../store/ui";
import Navigation from "./Navigation";
import { ErrorBoundary } from "../errors";

const Main = styled.main<{ pushContent?: boolean }>`
    min-height: 150px;
    margin-top: ${props => props.pushContent ? "150px" : "0px"};
`;

const Layout: React.FunctionComponent<StateProps> = (props) =>
{
    const { updateRouteItems, updateDomain } = props;

    useEffect(() =>
    {
        updateRouteItems();
        updateDomain();
    }, [updateRouteItems, updateDomain]);

    return (
        <React.Fragment>

            <GlobalStyle />
            {/* <TestBasket /> */}
            <Navigation />

            <Main>
                <ErrorBoundary>
                    {props.children}
                </ErrorBoundary>
            </Main>

            <Footer footerItems={props.domain?.footer && props.domain.footer ? props.domain.footer : []} />

        </React.Fragment>
    );
};

const mapStateToProps = (state: AppState) =>
{
    return {
        routeItems: getRouteItems(state.route),
        domain: getDomain(state.domain),
        backdrop: getBackdrop(state.ui)
    };
};

const mapToDispatchProps = (dispatch: AppThunkDispatch) =>
    ({
        updateRouteItems: () => dispatch(thunkUpdateRouteItems()),
        updateDomain: () => dispatch(thunkUpdateDomain()),
        showBasket: () => dispatch(showBasketAsync()),
        showLogin: () => dispatch(showLoginAsync())
    });

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapToDispatchProps>;

export default connect(mapStateToProps, mapToDispatchProps)(Layout);
